module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-a686e5ae.png";